import { Navigate } from "react-router";
import { useGetCuttingQuery } from "../../../apis/Cutting.api";
import { PrimaryCutting, Cutting } from "../../../types/models/Cutting";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const CuttingScoped = () => {
    const {
        data,
    } = useGetCuttingQuery(PrimaryCutting.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/cuttings/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default CuttingScoped;
